import * as ActionTypes from "services/state/action-types";
import partialRight from "ramda/src/partialRight";
import filter from "ramda/src/filter";

const RECHARGE_INITIAL_STATE = {
  loading: true,
  error: false,
  data: [],
  demand: null,
  scheduled: [],
  recharges: [],
  currentNumber: null,
  phoneNumbers: [],
  rechargeSelected: [],
  values: [],
  rechargeValues: [],
  scheduledRecharges: [],
  address: [],
  phoneInformation: null,
};

const filterByNumber = (item, currentNumber) => {
  return currentNumber ? item.phone === currentNumber : true;
};

const filterData = (item, currentNumber) => {
  return filterByNumber(item, currentNumber);
};

const filterHandler = (data, currentNumber) => {
  return filter(partialRight(filterData, [currentNumber]), data);
};

const removeRecharge = (recharge, scheduled) => {
  return filter((item) => {
    return item.recurrenceId !== recharge.recurrenceId;
  }, scheduled);
};

export function recharge(state = RECHARGE_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CHECK_PHONE_NUMBER:
    case ActionTypes.CHECK_CREDIT_CARD:
    case ActionTypes.CHANGE_SCHEDULE_RECHARGES:
    case ActionTypes.VERIFY_ADDRESS:
      return { ...state, loading: true, error: false };
    case ActionTypes.RECHARGE_REQUEST:
    case ActionTypes.GET_ADDRESS:
    case ActionTypes.GET_ADDRESS_ZIPCODE:
      return { ...state, loading: true };

    case ActionTypes.CHECK_PHONE_NUMBER_FAIL:
    case ActionTypes.CHECK_CREDIT_CARD_FAIL:
    case ActionTypes.GET_ADDRESS_FAIL:
    case ActionTypes.RECHARGE_REQUEST_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.CHECK_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        values: action.payload.rechargeValues,
        checkPhoneNumber: action.payload,
      };
    case ActionTypes.GET_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        address: action.payload,
      };

    case ActionTypes.GET_ADDRESS_ZIPCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...action.payload.data.resultData,
      };

    case ActionTypes.RECHARGE_REQUEST_SUCCESS:
    case ActionTypes.CHECK_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        creditCard: action.payload,
        error: false,
      };

    case ActionTypes.VERIFY_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        address: action.payload,
      };

    case ActionTypes.VERIFY_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case ActionTypes.SET_SELECTED_RECHARGE:
      return { ...state, rechargeSelected: action.payload };

    case ActionTypes.DELETE_SCHEDULED_RECHARGE:
      return { ...state, loading: true, error: false };

    case ActionTypes.DELETE_SCHEDULED_RECHARGE_SUCCESS:
      let filteredScheduled = removeRecharge(
        state.rechargeSelected,
        state.data.recurrentRecharges
      );

      return {
        ...state,
        data: action.payload,
        scheduled: filteredScheduled,
        rechargeSelected: null,
        loading: false,
      };

    case ActionTypes.DELETE_SCHEDULED_RECHARGE_FAIL:
      return {
        ...state,
        loading: false,
        rechargeSelected: null,
        error: true,
      };

    case ActionTypes.CHANGE_SCHEDULE_RECHARGES_SUCCESS:
      return { ...state, loading: false, scheduledRecharges: action.payload };

    case ActionTypes.CHANGE_SCHEDULE_RECHARGES_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.SET_PHONE_NUMBER:
      const filterRecharges = partialRight(filterHandler, [
        action.currentNumber,
      ]);

      return {
        ...state,
        currentNumber: action.currentNumber,
        recharges: filterRecharges(state.data.recharges),
        scheduled: filterRecharges(state.data.recurrentRecharges),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/recharge/reducer.js